// App-Shell-State, aus RootLayout (__root.tsx) herausgehoben, damit auch die
// Mobile-Shell-Bars (<640) die globalen Shell-Aktionen auslösen können:
//   - der Drawer (☰ Mobile-Sidebar) und
//   - das Notification-Center (🔔)
// lebten bislang als lokale useState im RootLayout. Das Muster folgt
// notification-store.ts / overlay-store.ts (zustand, ein Store pro Belang).
//
// `title` ist der Seitentitel der mobilen Top-Leiste (MobileShellTop).
// Routen setzen ihn via useMobilePageTitle (mobile-shell-outlets.tsx);
// ohne Registrierung fällt die Leiste auf den Nav-Label-Resolver
// (lib/mobile-title.ts) zurück. Bewusst nur ein String im Store — JSX
// gehört nicht in zustand (Stale-Closure-Falle), reiche Mitten portalen
// über MobileTopCenter.

import { create } from 'zustand'

interface ShellStore {
  /** Mobile-Sidebar-Drawer (☰). */
  drawerOpen: boolean
  openDrawer: () => void
  closeDrawer: () => void

  /** Notification-Center (🔔). */
  notifOpen: boolean
  openNotif: () => void
  closeNotif: () => void

  /** Seitentitel der mobilen Top-Leiste; null = Nav-Label-Fallback. */
  title: string | null
  setTitle: (t: string | null) => void

  /** Blendet die generische Bottom-Bar temporär aus, solange ein Seiten-
   *  Composer fokussiert ist (Chat, Risiko §5.2): auf Android schrumpft
   *  h-dvh mit der Tastatur — ohne Ausblenden säße die Menü-Bar als toter
   *  56px-Streifen ZWISCHEN Eingabefeld und Tastatur. Fokus-basiert statt
   *  visualViewport: kleinste saubere Lösung, kein Resize-Listener nötig.
   *  Seiten setzen das Flag bei Focus/Blur und räumen es beim Unmount auf. */
  suppressBottomBar: boolean
  setSuppressBottomBar: (v: boolean) => void
}

export const useShellStore = create<ShellStore>((set) => ({
  drawerOpen: false,
  openDrawer: () => set({ drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false }),

  notifOpen: false,
  openNotif: () => set({ notifOpen: true }),
  closeNotif: () => set({ notifOpen: false }),

  title: null,
  setTitle: (t) => set({ title: t }),

  suppressBottomBar: false,
  setSuppressBottomBar: (v) => set({ suppressBottomBar: v }),
}))
